<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm">
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-3 mark">
          <!-- Vanliga fel -->
          <div v-if="!message">
            <h1 v-html="data.error.errorHeader"></h1>
            <div class="clearfix"></div>
            <p v-html="data.error.errorText"></p>
          </div>
          <!-- Remiss fel -->
          <div v-if="message">
            <div class="header-wrapper">
              <h1 v-html="data.error.errorRemittanceHeader"></h1>
            </div>
            <div class="clearfix"></div>
            <p>{{ remittanceError }}</p>
            <p v-html="data.error.errorRemittanceText"></p>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-link--ext btn-lg btn-block"
            @click="$router.push('/')" v-html="data.error.toStartBtn"></button>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'

export default {
  name: 'error',
  props: ['message'],
  data () {
    return {
      data: null,
      language: sessionStorage.getItem('language'),
      remittanceError: this.message || null
    }
  },
  components: {},
  async mounted () {
    this.data = await request({
      query: `
        {
          error(locale: ` + sessionStorage.getItem('language') + `) {
            errorHeader
            errorRemittanceHeader
            errorRemittanceText
            errorText
            goBackBtn
            toStartBtn
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  padding-bottom: 6vh;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
.btn-link--ext {
  color: #1a61d3bb;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 4vh;
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Error.vue